import { isNull } from "lodash";
import { ofType, Epic, combineEpics } from "redux-observable";
import { merge, of } from "rxjs";
import { catchError, map, mergeMap, takeUntil } from "rxjs/operators";
import { selectAuthTokens } from "../../../features/auth/selectors/auth.selector";

import { dataFieldsActions } from "../../../features/data-fields/redux";
import { IAction } from "../../../interface/action.interface";
import { IErrorDto } from "../../../interface/dto/error.dto";
import { IRootState } from "../../../redux/root.reducer";
import {
    defaultEmailUpdateFrequency,
    defaultEmailUpdateTime,
} from "../const/email-updates";
import {
    getUserPreferences,
    updateUserPreferences,
} from "../services/user-preferences.api";
import { tooltipsActions, tooltipsEpic } from ".";
import {
    userPreferencesGetAction,
    userPreferencesGetErrorAction,
    userPreferncesGetSuccessAction,
    UserPreferencesActionTypes,
    userPreferncesUpdateSuccessAction,
    userPreferencesUpdateErrorAction,
} from "./user-preferences.action";

export const userPreferencesEpic: Epic<IAction, IAction, IRootState> = (
    action$,
    state$,
) =>
    merge(
        action$.pipe(
            ofType(UserPreferencesActionTypes.USERPREFERENCES_INIT),
            mergeMap(() => [
                userPreferencesGetAction(),
                dataFieldsActions.init(),
                tooltipsActions.init(),
            ]),
        ),
        action$.pipe(
            ofType(UserPreferencesActionTypes.USERPREFERENCES_GET),
            mergeMap(() =>
                getUserPreferences(selectAuthTokens()).pipe(
                    takeUntil(
                        action$.pipe(
                            ofType(
                                UserPreferencesActionTypes.USERPREFERENCES_GET,
                            ),
                        ),
                    ),
                    map((response) => userPreferncesGetSuccessAction(response)),
                    catchError((error: IErrorDto) =>
                        of(userPreferencesGetErrorAction(error.message)),
                    ),
                ),
            ),
        ),
        action$.pipe(
            ofType(UserPreferencesActionTypes.USERPREFERENCES_UPDATE),
            mergeMap(() => {
                const data = state$.value.userPreferences.page.data;
                return updateUserPreferences(
                    isNull(data.emailUpdateFrequency)
                        ? {
                              ...data,
                              emailUpdateFrequency: defaultEmailUpdateFrequency,
                              emailUpdateTime: defaultEmailUpdateTime,
                          }
                        : data,
                    selectAuthTokens(),
                ).pipe(
                    takeUntil(
                        action$.pipe(
                            ofType(
                                UserPreferencesActionTypes.USERPREFERENCES_UPDATE,
                            ),
                        ),
                    ),
                    map(() => userPreferncesUpdateSuccessAction()),
                    catchError((error: IErrorDto) =>
                        of(userPreferencesUpdateErrorAction(error.message)),
                    ),
                );
            }),
        ),
    );

export const userPreferencesPageEpic = combineEpics(
    userPreferencesEpic,
    tooltipsEpic,
);
